import { ClientConfig, DefaultStorageType, SSO_DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'dqtechus',
  ...SSO_DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/dqtechus/light-logo.png',
    darkLogo: 'assets/dqtechus/dark-logo.png',
    alt: 'DQTechnologies',
    width: '138px',
    height: '35px',
  },
  authRoutes: ['iframe-implicit-login', 'tsplogin', 'admin-login', 'unauthorized-error'],
  wildcardRoute: 'iframe-implicit-login',
  showLogoutButton: false,
  showHeader: false,
  showSideNav: false,
  showFeatureAnnouncement: false,
  defaultStorage: DefaultStorageType.SessionStorage,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
